import Icon, { ICONS } from '../icon';
import { useTranslate } from '../../../i18n/useTranslationModules';

import './rating-scale.scss';

interface IRatingScaleProps {
	onChange?: (value: number) => void;
	rating: number | null;
	unselectedIcon?: string;
	selectedIcon?: string;
	iconSize?: number;
	range?: number;
	spacing?: number;
	align?: 'flex-start' | 'center' | 'flex-end' | 'space-between';
	readonly?: boolean;
	disabled?: boolean;
}

export const RatingScale = ({
	onChange,
	rating,
	unselectedIcon = ICONS.STAR_OUTLINE,
	selectedIcon = ICONS.STAR,
	iconSize = 22,
	range = 5,
	spacing = 0,
	align = 'center',
	readonly = false,
	disabled = false,
}: IRatingScaleProps) => {
	const { t } = useTranslate('session');

	return (
		<div
			className='rating-scale'
			style={{ justifyContent: align }}
			role={readonly ? 'img' : undefined}
			aria-label={readonly ? t('userSurvey.rateStars', '{{rating}} out of {{range}} stars', { rating: String(rating ?? 0), range: String(range) }) : undefined}
		>
			{[...Array(range)].map((_, i) => {
				const selected = rating && rating > i;

				if (readonly) {
					return (
						<Icon
							key={i}
							name={selected ? selectedIcon : unselectedIcon}
							size={iconSize}
							color="" // Determined in CSS file
							ariaHidden
						/>
					);
				}

				return (
					<button
						className='user-survey-rating-star'
						key={i}
						onClick={onChange ? () => onChange(i + 1) : () => ''}
						style={{ marginLeft: i === 0 ? 0 : `${spacing}px` }}
						aria-label={t('userSurvey.rateStars', '{{rating}} out of {{range}} stars', { rating: String(i + 1), range: String(range) })}
						aria-pressed={rating === i + 1}
						disabled={disabled}
					>
						<Icon
							name={selected ? selectedIcon : unselectedIcon}
							size={iconSize}
							color="" // Determined in CSS file
							ariaHidden
						/>
					</button>
				);
			})}
		</div>
	);
};
